import $ from 'jquery';
import * as utils from './utils.js';
import { getParam } from 'utilsES';
import * as api from './api.js';
import { sendSuccData } from './reserveDataReport.js';
import Clipboard from 'clipboard';

let copyBtn = new Clipboard('.j-line-copy');
copyBtn.on('success', function (e) {
  alert('複製成功');
});
copyBtn.on('error', function (e) {
  alert('複製失敗');
});

const PHONE_KEY = 'bxjxyyPhone';
const TOKEN_KEY = 'bxjxyyToken';
const PHONE_MERGE_KEY = 'bxjxyyPhoneMerge';

let menuHasClcik = false;
let initPage = false;

/**
 * 台灣 +886
   香港 +852
   澳門 +853
   新加坡 +65
   馬來西亞 +60
 */
const phoneCode = {
  xianggang: 852,
  aomen: 853,
  taiwan: 886,
  xinjiapo: 65,
  malaixiya: 60,
};

export const menu = {
  navList: $('.j-desc-list li'),
  $navItem: $('.j-desc-list-item'),
  pageLocation: {
    part1: 0,
    part2: 0,
    part3: 0,
    part4: 0,
    part5: 0,
    partReward: 0,
  },
  navHeight: 0,
  $part1: document.querySelector('.j-part1'),
  $part2: document.querySelector('.j-part2'),
  $part3: document.querySelector('.j-part3'),
  $part4: document.querySelector('.j-part4'),
  $part5: document.querySelector('.j-part5'),
  $partReward: document.querySelector('.j-part-reward'),
  init() {
    const $descList = $('.j-desc-list');
    this.navList.eq(0).addClass('active');

    $('.j-desc-list-item').on('click', ({ target }) => {
      if (!target.parentElement.dataset.index) {
        return;
      }
      const index = target.parentElement.dataset.index * 1;
      this.scrollPage(index);
    });

    window.addEventListener('load', () => {
      this.updatePageLocation();
    });
    window.addEventListener(
      'resize',
      utils.throttle(() => {
        this.updatePageLocation();
      })
    );
    window.addEventListener(
      'scroll',
      utils.throttle(() => {
        this.changeNavActive([
          this.$part1,
          this.$part2,
          this.$part3,
          this.$part4,
          this.$part5,
        ]);
      }, 200)
    );
  },
  scrollPage(index) {
    this.$navItem
      .removeClass('active')
      .eq(index - 1)
      .addClass('active');
    $('html,body').animate(
      { scrollTop: $(this[`$part${index}`]).offset().top - 100 },
      100
    );
  },
  updatePageLocation() {
    let navClass = '.j-nav';
    this.navHeight = document
      .querySelector(navClass)
      .getBoundingClientRect().height;
    for (let i = 0; i < 5; i++) {
      this.pageLocation[`part${i + 1}`] = utils.computeEleLocation(
        this[`$part${i + 1}`]
      );
    }
    this.pageLocation['partReward'] = utils.computeEleLocation(
      this.$partReward
    );
  },
  changeNavActive(parts = []) {
    let scrollHeight = window.pageYOffset || document.documentElement.scrollTop;
    let index = 0;
    for (let i = 5; i >= 1; i--) {
      if (scrollHeight + 520 >= this.pageLocation[`part${i}`]) {
        index = i;
        break;
      }
    }
    this.$navItem
      .removeClass('active')
      .eq(index - 1)
      .addClass('active');

    if (index <= 2) {
      $('.j-fb-side').show();
    } else {
      $('.j-fb-side').hide();
    }
    if (scrollHeight + 120 >= this.pageLocation.part2) {
      $('.j-part-reward').addClass('active');
    }

    if (utils.isInViewPortOfOne(document.querySelector('.j-footer'))) {
      $('.j-m-fb-side').addClass('fixed-bottom');
    } else {
      $('.j-m-fb-side').removeClass('fixed-bottom');
    }
  },
};

export const popup = {
  $popup: $('.j-tip-popup'),
  $tip: $('.j-tip'),
  $popupClose: $('.j-popup-close'),
  $btn1: $('.j-popup-btn-1'),
  $btn2: $('.j-popup-btn-2'),
  event1: null,
  event2: null,
  closeHandlerBind: null,
  name: '',
  text: {
    agree: '請勾選條款，進行預約',
    phone: '手機門號格式錯誤',
    inschool: '入學登記成功',
    pred: '您已完成預約<br>邀請好友加入軍團可以獲得更多獎勵！',
    end: '活動已結束',
    joinJuntuan: '您當前還未加入軍團<br>加入公會領取獎勵',
    inputName: '請輸入軍團名稱',
    inputDesc: '請輸入軍團描述',
    sensitiveWord: '輸入內容含有敏感詞匯<br>請重新輸入',
    nameRepeat: '軍團名稱重複<br>請重新輸入',
    nameLengthOver: '名稱已超過20個字！',
    hasSpace: '名稱內不能含有空格',
    descLengthOver: '介紹已超過50個字',
    sysError: '系統錯誤',
    hasJuntuan: '您已有軍團',
    repeatName: '該軍團名已被創建',
    noExist: '軍團不存在',
    hasReach: '軍團人數已滿',
    hasGot: '您已領取過該獎勵',
    hasNotReach: '軍團人數未達到',
    lineError: '鏈接格式不正確',
    inputError: '輸入內容只能使用中文、英文和數字。',
    lineInputWrong: '請輸入正確的LINE群連結',
    lineEditSucc: 'LINE群連結修改成功'
  },
  showPopup(name) {
    // this.name = name;
    // this.closeHandlerBind = this.closeHandler.bind(popup);
    // this.$popup.addClass(name);
    this.$tip.html(this.text[name]);
    this.$popup.fadeIn();
    // this.$popupClose.on('click', this.closeHandlerBind);
  },
  addEvent(event1, event2) {
    event1 &&
      (this.event1 = event1.bind(popup)) &&
      this.$btn1.on('click', this.event1);
    event2 &&
      (this.event2 = event2.bind(popup)) &&
      this.$btn2.on('click', this.event2);
  },
  closeHandler() {
    this.$popup.hide();
    this.$popup.removeClass(this.name);
    this.name = '';
    this.$popupClose.off('click', this.closeHandlerBind);
    this.$btn1.off('click', this.event1);
    this.$btn2.off('click', this.event2);
  },
};

export const preNum = {
  $preNum: $('.j-pre-num'),
  totalNum: 0,
  init() {
    // this.update();
    this.totalNum = 904365
    this.initProgress()
  },
  update() {
    api
      .getReserveInfo()
      .then(({ data }) => {
        const num = data.TOTAL_RESERVED_NUM || data.total_reserved_num;
        this.totalNum = +num;
        this.$preNum.text(num);
        this.initProgress();
      })
      .catch(err => {
        this.$preNum.text(0);
      });
  },
  initProgress() {
    const levelMap = {
      100000: '.j-level-1',
      200000: '.j-level-2',
      400000: '.j-level-3',
      700000: '.j-level-4',
      1000000: '.j-level-5',
    };
    Object.keys(levelMap).forEach(item => {
      if (this.totalNum >= +item) {
        $(levelMap[item]).addClass('active');
      }
    });
  },
};

// 首页下载 part1
export const download = {
  $popup: $('.j-popup'),
  $popupClose: $('.j-popup-close'),
  $btn1: $('.j-popup-btn-1'),
  $btn2: $('.j-popup-btn-2'),
  fullpageAPI: null,
  toRegisterBind: null,
  toShopBind: null,
  closeHandlerBind: null,
  downType: '',
  init(fullpageAPI) {
    this.fullpageAPI = fullpageAPI;
    this.toRegisterBind = this.toRegister.bind(this);
    this.toShopBind = this.toShop.bind(this);
    this.closeHandlerBind = this.closeHandler.bind(this);
    this.toRegPageBind = this.toRegPage.bind(this);
    this.event();
  },
  event() {
    $('.j-apple').on('click', ({ target }) => {
      // window.open('https://apps.apple.com/tw/app/id1560634468', '_blank');
      this.downType = target.dataset.shop;
      this.showPopup('back');
      this.$btn1.on('click', this.toRegisterBind);
      this.$btn2.on('click', this.toShopBind);
    });
    $('.j-google').on('click', ({ target }) => {
      window.open(
        'https://play.google.com/store/apps/details?id=com.blancozone.dlssr.gp',
        '_blank'
      );
      this.downType = target.dataset.shop;
      // this.showPopup('back');
      // this.$btn1.on('click', this.toRegisterBind);
      // this.$btn2.on('click', this.toShopBind);
    });
  },
  showPopup(name) {
    this.$popup.addClass(name);
    this.$popup.fadeIn();
    this.$popupClose.on('click', this.closeHandlerBind);
  },
  toRegister() {
    this.closeHandlerBind();
    menu.changePage(2);
  },
  toShop() {
    this.closeHandlerBind();
    if (this.downType == 'google') {
      // this.showPopup('continue');
      // this.$btn1.on('click', this.toRegisterBind);
      // this.$btn2.on('click', this.toRegPageBind);
      this.toRegPage();
    } else {
      if (utils.whatDevice() == 'mobile') {
        // this.showPopup('continue');
        // this.$btn1.on('click', this.toRegisterBind);
        // this.$btn2.on('click', this.toRegPageBind);
        this.toRegPage();
        return;
      }
      if (utils.whatDevice() == 'pc') {
        this.showPopup('tophone');
      }
    }
  },
  closeHandler() {
    this.$popup.hide();
    this.$popup
      .removeClass('back')
      .removeClass('continue')
      .removeClass('tophone');
    this.$popupClose.off('click', this.closeHandlerBind);
    this.$btn1.off('click', this.toRegisterBind);
    this.$btn2.off('click', this.toShopBind);
  },
  toRegPage() {
    this.closeHandlerBind();
    // console.log(11);
    window.open('https://dlssr.onelink.me/5yNJ/gp', '_blank');
  },
};

// 预约 part2
export const register = {
  device: 'ios',
  area: 'taiwan',
  code: '',
  check: true,
  init() {
    this.event();
  },
  event() {
    const $device = $('.j-device');
    const $areaList = $('.j-area-list');
    const $area = $('.j-area');
    const $areaSelected = $('.j-area-selected');
    const $areaArrow = $('.j-area-arrow');
    const $formSubmit = $('.j-form-confirm');
    const $check = $('.j-check');
    const $phone = $('.j-phone');

    $check.on('click', () => {
      if (this.check) {
        this.check = false;
        $check.removeClass('active');
      } else {
        this.check = true;
        $check.addClass('active');
      }
    });

    $device.on('click', ({ target }) => {
      const device = target.dataset.device;
      if (device == 'android' || device == 'ios') {
        this.device = device;
        const otherDevice = device == 'android' ? 'ios' : 'android';
        $(`.device-${otherDevice}`).removeClass('active');
        $(target).addClass('active');
      }
    });

    $area.on('click', e => {
      $areaList.toggle();
      $areaArrow.toggleClass('active');
    });

    $areaList.on('click', ({ target }) => {
      const area = target.dataset.area;
      const areaArr = [
        'select',
        'xianggang',
        'taiwan',
        'aomen',
        'xinjiapo',
        'malaixiya',
      ];
      const areaMap = {
        xianggang: '香港',
        aomen: '澳門',
        taiwan: '台灣',
        xinjiapo: '新加坡',
        malaixiya: '馬來西亞',
      };
      if (areaArr.includes(area) && area != 'select') {
        this.area = area;
        areaArr.forEach(item => {
          $areaSelected.removeClass(item);
        });
        $areaSelected.addClass(area);
        $areaSelected.html(areaMap[area]);
        $('.j-phone-code').html(phoneCode[area]);
      }
      $areaList.hide();
      $areaArrow.removeClass('active');
    });

    $formSubmit.on('click', () => {
      // 判断活动是否已结束
      if (!this.check) {
        popup.showPopup('agree');
        return;
      }
      const areaMap = {
        xianggang: '香港',
        aomen: '澳門',
        taiwan: '台灣',
        xinjiapo: '新加坡',
        malaixiya: '馬來西亞',
      };
      let phone = $phone.text().trim();
      // 校验手机格式
      let phoneFormate = {
        taiwan: /^\d{10}$/,
        xianggang: /^\d{8}$/,
        aomen: /^\d{8}$/,
        xinjiapo: /^\d{8}$/,
        malaixiya: /(^01\d{8,9}$)|(^1\d{8,10}$)/,
      };
      phoneFormate[this.area].lastIndex = 0;
      if (!phoneFormate[this.area].test(phone)) {
        popup.showPopup('phone');
        return;
      }
      const submitForm = {
        area: areaMap[this.area],
        device: this.device,
        phone: phone,
        phone_code: phoneCode[this.area],
        scid: getParam('scid'),
        cid: getParam('cid'),
      };
      api
        .doReserve(submitForm)
        .then(res => {
          $('.j-popup').hide();
          if (res.data.isRepeat) {
            popup.showPopup('pred');
          } else {
            $('.j-reserve-succ-popup').fadeIn();
          }
          // preNum.init();
          dataLayer.push({ event: 'reserVationSuccess' });
          sendSuccData();
          this.initLoginStatus(submitForm.phone, res);
          menhui.init();
        })
        .catch(({ code, msg }) => {
          if (code == -254) {
            popup.showPopup('pred');
            this.initLoginStatus(submitForm.phone, res);
            menhui.init();
          }
          if (code == -20006 || code == -1006) {
            popup.showPopup('end');
          }
          if (code == -10087) {
            popup.showPopup('phone');
          }

          dataLayer.push({
            event: 'reservationFail',
            reason: msg,
          });
        });

      // 各种弹窗
      // popup.showPopup('inschool');
      // popup.showPopup('registered');
      // popup.addEvent(
      // 	() => {
      // 		alert('login');
      // 		popup.closeHandlerBind();
      // 	},
      // 	() => {
      // 		popup.closeHandlerBind();
      // 	});
    });
  },
  initLoginStatus(phone, res) {
    localStorage.setItem(PHONE_KEY, phone);
    res.data &&
      res.data.token &&
      localStorage.setItem(TOKEN_KEY, res.data.token);
    res.data &&
      res.data.phoneMerge &&
      localStorage.setItem(PHONE_MERGE_KEY, res.data.phoneMerge);
    login.initLogin();
  },
};

// 世界观 part4
export const world = {
  $baseNav: $('.j-base-nav li'),
  $textList: $('.j-text li'),
  curSection: 'role',
  showingText: false,
  curText: 1,
  timerArr: [],
  init() {
    this.event();
  },
  event() {
    //  模块切换
    $('.j-btn-section').on('click', ({ target }) => {
      const section = target.dataset.section;
      if (this.curSection == section) {
        return;
      }
      this.clearText();
      if (section == 'base') {
        this.showText();
      }
      const sectionArr = ['base', 'role', 'map'];
      const sectionPart = [
        {
          section: 'base',
          ele: $('.j-part4-base'),
        },
        {
          section: 'role',
          ele: $('.j-part4-role'),
        },
        {
          section: 'map',
          ele: $('.j-part4-map'),
        },
      ];
      if (sectionArr.includes(section)) {
        this.curSection = section;
        sectionPart.forEach(item => {
          if (item.section == section) {
            item.ele.fadeIn();
          } else {
            item.ele.fadeOut();
          }
        });
      }
    });
    // 文字切换
    $('.j-base-nav').on('click', ({ target }) => {
      const nav = target.dataset.nav * 1;
      this.changeText(nav);
    });
  },
  changeText(nav) {
    if (this.curText == nav) {
      return;
    }
    this.curText = nav;
    if (nav <= 4 || nav >= 1) {
      this.$baseNav
        .removeClass('active')
        .eq(nav - 1)
        .addClass('active');
      this.$textList
        .hide()
        .eq(nav - 1)
        .show();
      this.$textList.find('p').removeClass('active');
      const $p = this.$textList.eq(nav - 1).find('p');
      this.timerArr.forEach(item => {
        clearTimeout(item);
      });
      this.timerArr = [];
      $p.each((index, ele) => {
        const timer = setTimeout(() => {
          $(ele).addClass('active');
        }, 300 * index);
        this.timerArr.push(timer);
      });
    }
  },
  clearText() {
    this.timerArr.forEach(item => {
      clearTimeout(item);
    });
    this.$textList.find('p').removeClass('active');
  },
  showText() {
    const $p = this.$textList.eq(this.curText - 1).find('p');
    this.timerArr.forEach(item => {
      clearTimeout(item);
    });
    this.timerArr = [];
    $p.each((index, ele) => {
      const timer = setTimeout(() => {
        $(ele).addClass('active');
      }, 300 * index);
      this.timerArr.push(timer);
    });
  },
};

// 人物切换 part4
export const role = {
  $roleHead: $('.j-role-head'),
  $roleItem: $('.j-role-item'),
  $roleMain: $('.j-role-main'),
  $roleMain1: $('.j-role-main-1'),
  $roleMain2: $('.j-role-main-2'),
  $roleVideo: $('.j-role-video'),
  $roleLeft: $('.j-role-left'),
  $roleRight: $('.j-role-right'),
  init() {
    this.event();
  },
  event() {
    this.$roleHead.on('click', ({ target }) => {
      const role = target.dataset.role;
      const roles = ['liemoren', 'wushi', 'fashi', 'zhanshi'];
      const roleVideo = {
        liemoren: 'https://www.youtube.com/embed/dWciAGl9Huo',
        wushi: 'https://www.youtube.com/embed/N-Asz4bHz-s',
        fashi: 'https://www.youtube.com/embed/aCw-HVdxDv0',
        zhanshi: 'https://www.youtube.com/embed/R4ZcSpc7_Qo',
      };
      const next = {
        liemoren: {
          left: 'zhanshi',
          right: 'wushi',
        },
        wushi: {
          left: 'liemoren',
          right: 'fashi',
        },
        fashi: {
          left: 'wushi',
          right: 'zhanshi',
        },
        zhanshi: {
          left: 'fashi',
          right: 'liemoren',
        },
      };
      if (roles.includes(role)) {
        if (this.$roleMain2.hasClass(role)) {
          return;
        }
        roles.forEach(item => {
          this.$roleItem.removeClass('active');
          this.$roleMain1.removeClass(item);
        });
        $(target).addClass('active');
        this.$roleMain1.addClass(role);
        // this.$roleMain.css({
        //   transform: 'translateX(-80%)',
        //   transition: 'transform .3s',
        // });
        setTimeout(() => {
          roles.forEach(item => {
            this.$roleMain2.removeClass(item);
          });
          this.$roleMain2.addClass(role);
          this.$roleVideo.attr('data-link', roleVideo[role]);
          // this.$roleMain.css({
          //   transform: 'translateX(-50%)',
          //   transition: 'transform 0s',
          // });
          this.$roleLeft
            .attr('data-role', next[role].left)
            .attr('data-manual', 'click-page4-' + next[role].left);
          this.$roleRight
            .attr('data-role', next[role].right)
            .attr('data-manual', 'click-page4-' + next[role].right);
        }, 100);
      }
    });
  },
};

export const commonEvent = function () {
  $('.j-ytb-btn').on('click', function () {
    let link = $(this).attr('data-link');
    let device = utils.whatDevice();
    const sizeMap = {
      pc: {
        width: window.innerWidth / 2,
        height: window.innerHeight / 2,
      },
      mobile: {
        width: (window.innerWidth * 95) / 100,
        height: (window.innerWidth * 95) / 100,
      },
    };
    let htmlStr = `<iframe width="${sizeMap[device].width}px" height="${sizeMap[device].height}px" src="${link}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    link && $('.j-video-iframe').html(htmlStr);
    $('.j-video-popup').fadeIn();
  });

  $('.j-shade').on('click', function () {
    $('.j-popup').fadeOut();
    $('.j-video-iframe').html('');
  });

  $('.j-close-tip').on('click', function () {
    $('.j-tip-popup').fadeOut();
  });

  $('.j-reserve-btn').on('click', function () {
    $('.j-reserve-popup').fadeIn();
  });

  window.addEventListener('load', function () {
    let html =
      '<iframe width="100%" height="100%" type="text/html" src="https://www.youtube.com/embed/ACYkoI-maOs?widgetid=1&mute=1&rel=0&enablejsapi=1&version=3&autoplay=true&controls=0&loop=1&modestbranding=1&playlist=ACYkoI-maOs" allow="autoplay" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" frameborder="0"></iframe>';
    $('.j-top-video').html(html);
  });

  $('body').on('click', '.j-manual-event', function () {
    const event = $(this).attr('data-manual');
    dataLayer.push({
      event: 'creatEvt',
      manualEvent: event,
    });
  });

  $('#searchInput').focus(function () {
    $('.j-m-fb-side').hide()
  }).blur(function () {
    $('.j-m-fb-side').show()
  })
};

export const mutiCidGpLinkInit = function () {
  const cid = getParam('cid') || '';
  const gpLink = {
    82: 'https://awake.onelink.me/zdD7?pid=bluestacks_int&c=bluestacks_int&af_web_dp=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.gm99.awake&gameID=59&cid=82',
    83: 'https://awake.onelink.me/zdD7?pid=ldplayer_int&c=ldplayer_int&af_web_dp=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.gm99.awake&gameID=59&cid=83',
    84: 'https://awake.onelink.me/zdD7?pid=bignox_int&c=bignox_int&af_web_dp=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.gm99.awake&gameID=59&cid=84',
    85: 'https://awake.onelink.me/zdD7?pid=qooapp_int&c=qooapp_int&af_web_dp=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.gm99.awake&gameID=59&cid=85',
  };
  gpLink[+cid] ? $('.j-google-btn').attr('href', gpLink[+cid]) : '';
};

export const login = {
  hasInit: false,
  isLogin: false,
  phone: '',
  token: '',
  phoneMerge: '',
  initLogin() {
    this.checkLogin();
    !this.hasInit && this.bindEvent();
    this.hasInit = true;
  },
  bindEvent() {
    $('.j-login-btn').on('click', function () {
      $('.j-reserve-popup').fadeIn();
    });
  },
  checkLogin() {
    let phone = localStorage.getItem(PHONE_KEY);
    let token = localStorage.getItem(TOKEN_KEY);
    let phoneMerge = localStorage.getItem(PHONE_MERGE_KEY);
    if (phone && token && phoneMerge) {
      this.phone = phone;
      this.token = token;
      this.phoneMerge = phoneMerge;
      this.isLogin = true;
      this.initLoginShow();
    }
  },
  initLoginShow() {
    if (this.isLogin) {
      $('.j-login-btn').hide();
      $('.j-login-phone').addClass('show');
      $('.j-wel-phone').html(
        this.phone.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2')
      );
    }
  },
};

export const menhui = {
  hasInit: false,
  isJoinJuntuan: false,
  myJuntuanInfo: {
    groupInfo: {
      groupName: '',
      discription: '',
      line: '',
      pic: 0,
    },
    memberTotal: 0,
    awardState: {
      // value:0不可领，1可领，2已领
      1: 0,
      2: 0,
      3: 0,
    },
    isCreater: false
  },
  list: {
    totalPage: 1,
    nowPage: 1,
    nowType: 1, //1时间，2热度
    nowList: [],
    search: '',
  },
  init() {
    this.reset();
    login.isLogin && this.checkHasJoinJuntuan();
    this.initJuntuanList();
    !this.hasInit && this.bindEvent();
    this.hasInit = true;
  },
  reset() {
    this.list.totalPage = 1;
    this.list.nowPage = 1;
    this.list.nowType = 1;
    this.list.search = '';
    this.isJoinJuntuan = false;
  },
  checkHasJoinJuntuan() {
    api
      .myGroup({
        phoneMerge: login.phoneMerge,
        token: login.token,
      })
      .then(res => {
        this.isJoinJuntuan = true;
        this.myJuntuanInfo.groupInfo = res.data.groupInfo;
        this.myJuntuanInfo.memberTotal = +res.data.memberTotal;
        this.myJuntuanInfo.awardState = res.data.awardState;
        this.myJuntuanInfo.isCreater = res.data.isCreater || false;
        this.initMyJuntuanPopup();
      })
      .catch(({ code, msg }) => { });
  },
  initMyJuntuanPopup() {
    let icoClass = '';
    for (let i = 0; i < 8; i++) {
      icoClass += `ico-${i} `;
    }
    $('.j-popup-my-juntuan-ico')
      .removeClass(icoClass)
      .addClass(`ico-${this.myJuntuanInfo.groupInfo.pic}`);
    $('.j-popup-my-juntuan-name').html(
      `${this.myJuntuanInfo.groupInfo.groupName}(${this.myJuntuanInfo.memberTotal}/20)`
    );
    $('.j-popup-my-juntuan-desc').html(
      this.myJuntuanInfo.groupInfo.discription
    );
    $('.j-popup-my-juntuan-line').val(
      this.myJuntuanInfo.groupInfo.line
        ? this.myJuntuanInfo.groupInfo.line
        : '暫無連結'
    );
    $('.j-line-copy').attr(
      'data-clipboard-text',
      this.myJuntuanInfo.groupInfo.line ? this.myJuntuanInfo.groupInfo.line : ''
    );
    const statusClassMap = {
      0: 'cannotget',
      1: 'canget',
      2: 'hasget',
    };
    let awardState = this.myJuntuanInfo.awardState;
    Object.keys(awardState).forEach(item => {
      $('.j-popup-my-juntuan-reward')
        .eq(+item - 1)
        .removeClass('cannotget canget hasget')
        .addClass(statusClassMap[awardState[item]]);
    });
    if (!this.myJuntuanInfo.isCreater) {
      $('.j-popup-my-juntuan-line').prop('disabled', true)
    } else {
      $('.j-popup-my-juntuan-line').prop('disabled', false)
    }
  },
  initJoinJuntuanPopup(listIndex) {
    if (this.isJoinJuntuan) {
      $('.j-popup-chakan-juntuan-join').hide();
      let line = ''
      if (this.list.nowList[listIndex].groupInfo.groupName == this.myJuntuanInfo.groupInfo.groupName) {
        line = this.myJuntuanInfo.groupInfo.line ? this.myJuntuanInfo.groupInfo.line : '暫無連結'
      } else {
        line = '加入後，可查看line群鏈結'
      }
      $('.j-popup-chakan-juntuan-line').html(line);
    } else {
      $('.j-popup-chakan-juntuan-join').show();
      $('.j-popup-chakan-juntuan-line').html('加入後，可查看line群鏈結');
    }
    $('.j-popup-chakan-juntuan-name').html(
      this.list.nowList[listIndex].groupInfo.groupName
    );
    $('.j-popup-chakan-juntuan-join,.j-join-sure').attr(
      'data-name',
      this.list.nowList[listIndex].groupInfo.groupName
    );
    $('.j-popup-chakan-juntuan-desc').html(
      this.list.nowList[listIndex].groupInfo.discription
    );
    let icoClass = '';
    for (let i = 0; i < 8; i++) {
      icoClass += `ico-${i} `;
    }
    $('.j-popup-chakan-juntuan-ico')
      .removeClass(icoClass)
      .addClass(`ico-${this.list.nowList[listIndex].groupInfo.pic}`);
  },
  bindEvent() {
    const self = this;
    $('.j-my-juntuan').on('click', () => {
      if (!login.isLogin) {
        $('.j-reserve-popup').fadeIn();
        return;
      }
      if (!this.isJoinJuntuan) {
        popup.showPopup('joinJuntuan');
        return;
      }
      self.initMyJuntuanPopup()
      $('.j-popup-my-juntuan').fadeIn();
    });

    $('.j-create-juntuan').on('click', () => {
      if (!login.isLogin) {
        $('.j-reserve-popup').fadeIn();
        return;
      }
      if (this.isJoinJuntuan) {
        $('.j-popup-has-juntuan').fadeIn();
        return;
      }
      $('.j-popup-create').fadeIn();
    });

    $('.j-create-juntuan-popup').on('click', () => {
      const name = $('.j-popup-create-name').val().trim();
      const desc = $('.j-popup-create-desc').val().trim();
      const line = $('.j-popup-create-line').val().trim();
      if (!name) {
        popup.showPopup('inputName');
        return;
      }

      if (name.indexOf(' ') > -1) {
        popup.showPopup('hasSpace');
        return;
      }

      if (name.length > 20) {
        popup.showPopup('nameLengthOver');
        return;
      }
      if (!desc) {
        popup.showPopup('inputDesc');
        return;
      }
      if (desc.length > 50) {
        popup.showPopup('descLengthOver');
        return;
      }
      if (line && !/^https?:\/\/line.me\//.test(line)) {
        popup.showPopup('lineError');
        return;
      }
      api
        .createGroup({
          phoneMerge: login.phoneMerge,
          token: login.token,
          groupName: encodeURIComponent(name),
          discription: encodeURIComponent(desc),
          line: encodeURIComponent(line),
        })
        .then(res => {
          $('.j-popup-create-succ').fadeIn();
          this.checkHasJoinJuntuan();
        })
        .catch(({ code, msg }) => {
          if (code == -20002 || code == -20003) {
            popup.showPopup('sysError');
            return;
          }
          if (code == -20004) {
            popup.showPopup('hasJuntuan');
            return;
          }
          if (code == -20005) {
            popup.showPopup('repeatName');
            return;
          }
          if (code == -20006) {
            popup.showPopup('sensitiveWord');
            return;
          }
          if (code == -20014 || code == -20015) {
            popup.showPopup('inputError');
            return;
          }
        });
    });

    $('.j-popup-my-juntuan-reward').on('click', function () {
      let index = $(this).attr('data-index');
      if ($(this).hasClass('cannotget') || $(this).hasClass('hasget')) {
        return;
      }
      // 领奖
      if ($(this).hasClass('canget')) {
        api
          .groupAward({
            phoneMerge: login.phoneMerge,
            token: login.token,
            level: index,
          })
          .then(res => {
            $('.j-popup-lunqu-succ').fadeIn();
            self.checkHasJoinJuntuan();
          })
          .catch(({ code, msg }) => {
            if (code == -20002 || code == -20003) {
              popup.showPopup('sysError');
              return;
            }
            if (code == -20010) {
              popup.showPopup('hasGot');
              return;
            }
            if (code == -20012) {
              popup.showPopup('hasNotReach');
              return;
            }
          });
      }
    });

    $('body').on('click', '.j-join-juntuan', function () {
      if (!login.isLogin) {
        $('.j-reserve-popup').fadeIn();
        return;
      }
      const index = $(this).attr('data-index');
      self.initJoinJuntuanPopup(index);
      $('.j-popup-chakan-juntuan').fadeIn();
    });

    $('.j-popup-chakan-juntuan-join').on('click', function () {
      $('.j-popup-ask-join').fadeIn();
    });

    $('.j-join-cancel').on('click', function () {
      $('.j-popup-ask-join').fadeOut();
    });

    $('.j-join-sure').on('click', function () {
      const name = $(this).attr('data-name');
      api
        .joinGroup({
          phoneMerge: login.phoneMerge,
          token: login.token,
          groupName: encodeURIComponent(name),
        })
        .then(res => {
          $('.j-popup-ask-join,.j-popup-chakan-juntuan').hide();
          $('.j-popup-create-succ-tip-1').html('成功加入');
          $('.j-popup-create-succ-tip-2').hide();
          $('.j-popup-create-succ').fadeIn();
          self.checkHasJoinJuntuan();
        })
        .catch(({ code, msg }) => {
          if (code == -20002 || code == -20003) {
            popup.showPopup('sysError');
            return;
          }
          if (code == -20004) {
            popup.showPopup('hasJuntuan');
            return;
          }
          if (code == -20020) {
            popup.showPopup('noExist');
            return;
          }
          if (code == -20007) {
            popup.showPopup('hasReach');
            return;
          }
        });
    });

    $('body').on('click', '.j-page-next', () => {
      if (this.list.nowPage == this.list.totalPage) {
        return;
      }

      this.list.nowPage++;
      this.initJuntuanList();
    });

    $('body').on('click', '.j-page-prev', () => {
      if (this.list.nowPage == 1) {
        return;
      }

      this.list.nowPage--;
      this.initJuntuanList();
    });
    $('body').on('click', '.j-page', function () {
      let page = $(this).attr('data-page');
      if (self.list.nowPage == page || page == 0) {
        return;
      }
      self.list.nowPage = page;
      self.initJuntuanList();
    });
    $('.j-update-type').on('click', function () {
      let type = $(this).attr('data-type');
      if (type == self.list.nowType) {
        return;
      }
      $('.j-update-type').removeClass('active');
      $(this).addClass('active');
      self.list.nowType = type;
      self.list.nowPage = 1;
      self.initJuntuanList();
    });

    $('.j-search-btn').on('click', () => {
      let val = $('.j-search-input').val();
      if (!val) {
        popup.showPopup('inputName');
        return;
      }
      this.list.search = val;
      this.list.nowPage = 1;
      this.initJuntuanList();
    });

    $('.j-refresh').on('click', () => {
      this.list.nowType = 1;
      this.list.nowPage = 1;
      this.list.search = '';
      this.initJuntuanList();
      $('.j-update-type').removeClass('active').eq(0).addClass('active');
    });

    $('.j-rule').on('click', () => {
      $('.j-popup-rule').fadeIn();
    });

    $('.j-bag').on('click', () => {
      if (!login.isLogin) {
        $('.j-reserve-popup').fadeIn();
        return;
      }
      api
        .awardLog({
          phoneMerge: login.phoneMerge,
          token: login.token,
        })
        .then(res => {
          const reward = {
            reserve_award: '金幣10000、2倍經驗卷軸*1、2級寶石禮包*1',
            award_1: '金鑽*30、2倍經驗卷軸*1、金幣10000',
            award_2: '無暇星光草*5、3級寶石禮包*1、尋寶藥水(小)*1',
            award_3: '初級強化石*1、天使寶藏券（綁）*1、金幣10000',
          };
          let html = `<div class="item">
          <div class="name head">獎勵名稱</div>
          <div class="time head">時間</div>
        </div>`;
          res &&
            res.data &&
            res.data.length &&
            res.data.forEach(item => {
              html += `<div class="item">
            <div class="name">${reward[item.awardKey]}</div>
            <div class="time">${item.time}</div>
          </div>`;
            });
          $('.j-bag-wrap').html(html);
          $('.j-popup-bag').fadeIn();
        })
        .catch(({ code, msg }) => {
          if (code == -20002 || code == -20003) {
            popup.showPopup('sysError');
            return;
          }
        });
    });

    $('.j-popup-my-juntuan-line').focus(function () {
      if ($(this).val() == '暫無連結') {
        $(this).val('')
      }
    }).blur(function () {
      let val = $(this).val().trim()

      if (!val) {
        popup.showPopup('lineInputWrong');
        return;
      }

      if (val == self.myJuntuanInfo.groupInfo.line) {
        return
      }

      if (val && !/^https?:\/\/line.me\//.test(val)) {
        popup.showPopup('lineInputWrong');
        return;
      }

      api
        .editLine({
          phoneMerge: login.phoneMerge,
          token: login.token,
          line: encodeURIComponent(val)
        })
        .then(res => {
          self.myJuntuanInfo.groupInfo.line = val
          popup.showPopup("lineEditSucc")
        })
        .catch(({ code, msg }) => {
          if ([-20002, -20003, -20016, -20017].includes(code)) {
            popup.showPopup('sysError');
            return;
          }
        });
    })
  },
  initJuntuanList(page) {
    api
      .groupList({
        sortType: this.list.nowType.toString(),
        page: page ? page.toString() : this.list.nowPage.toString(),
        search: this.list.search ? encodeURIComponent(this.list.search) : '',
      })
      .then(res => {
        this.list.totalPage = +res.data.pageTotal;
        this.list.nowList = res.data.list;
        this.renderPage();
        this.renderList(res.data.list);
      })
      .catch(({ code, msg }) => { });
  },
  renderList(list) {
    let html = ``;
    list.forEach((item, index) => {
      html += `<li class="juntuan-item">
      <div class="juntuan-item-left">
        <div class="juntuan-item-ico ico-${item.groupInfo.pic}"></div>
        <div class="juntuan-item-name">${item.groupInfo.groupName}(${item.memberTotal}/20)</div>
      </div>
      <div class="juntuan-item-btn j-join-juntuan j-manual-event" data-manual="click-page3-join-juntuan" data-index="${index}" data-name="${item.groupInfo.groupName}"></div>
    </li>`;
    });
    $('.j-juntuan-list').html(
      html ? html : '<p class="no-item">無相關信息</p>'
    );
  },
  getPage() {
    let totalPage = +this.list.totalPage;
    let nowPage = +this.list.nowPage;
    let arr = [];
    if (totalPage <= 5) {
      for (let i = 1; i <= totalPage; i++) {
        arr.push(i);
      }
      return arr;
    }
    if (nowPage <= 2) return [1, 2, 3, 0, totalPage];
    if (nowPage >= totalPage - 1)
      return [1, 0, totalPage - 2, totalPage - 1, totalPage];
    if (nowPage === 3) return [1, 2, 3, 4, 0, totalPage];
    if (nowPage === totalPage - 2)
      return [1, 0, totalPage - 3, totalPage - 2, totalPage - 1, totalPage];
    return [1, 0, nowPage - 1, nowPage, nowPage + 1, 0, totalPage];
  },
  renderPage() {
    let pagePrevHtml = '<span class="btn j-page-prev">&lt;</span>';
    let pageNextHtml = '<span class="btn j-page-next">&gt;</span>';
    let nowPage = this.list.nowPage;
    let arr = this.getPage();
    for (let i = 0; i < arr.length; i++) {
      pagePrevHtml += `<span class="btn j-page ${arr[i] == nowPage ? 'active' : ''
        }" data-page="${arr[i]}">${arr[i] ? arr[i] : '...'}</span>`;
    }
    $('.j-pagegation-wrap').html(pagePrevHtml + pageNextHtml);
  },
};
